/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMoodTongue = createReactComponent("mood-tongue", "IconMoodTongue", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M9 10l.01 0", key: "svg-1" }],
  ["path", { d: "M15 10l.01 0", key: "svg-2" }],
  ["path", { d: "M10 14v2a2 2 0 0 0 4 0v-2m1.5 0h-7", key: "svg-3" }]
]);

export { IconMoodTongue as default };
//# sourceMappingURL=IconMoodTongue.js.map
